/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/no-unused-state */
/* eslint-disable consistent-return */
/* eslint-disable @scandipwa/scandipwa-guidelines/only-render-in-component */
/* eslint-disable eqeqeq */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable max-lines */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable fp/no-let */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { Popup as ReactPopup } from 'reactjs-popup';

import CloseIcon from 'Component/CloseIcon';
import Image from 'Component/Image';
import Loader from 'Component/Loader';
import MyAccountAddressTable from 'Component/MyAccountAddressTable';
import Popup from 'Component/Popup';
import ReturnsForm from 'Component/ReturnsForm';
import { orderType } from 'Type/Account';
import { DISPLAY_CART_TAX_IN_SHIPPING_EXL_TAX } from 'Util/Cart';
import {
    isAusStore, isIntStore, isRsaStore, isUsaStore
} from 'Util/FrontRunner/Store';
import { formatPrice } from 'Util/Price';

import { ORDER_POPUP_ID } from './MyAccountOrderPopup.config';

import './MyAccountOrderPopup.style';

/** @namespace Pwa/Component/MyAccountOrderPopup/Component/MyAccountOrderPopupComponent */
export class MyAccountOrderPopupComponent extends PureComponent {
    static propTypes = {
        order: orderType.isRequired,
        rawInvoice: PropTypes.object.isRequired,
        isLoading: PropTypes.bool.isRequired,
        currency_code: PropTypes.string.isRequired,
        display_tax_in_shipping_amount: PropTypes.string,
        requestInvoicePdfDetails: PropTypes.func.isRequired
    };

    state = {
        activeTab: 'order',
        retunesFrom: false
    };

    static defaultProps = {
        display_tax_in_shipping_amount: ''
    };

    renderBaseInfo() {
        const { order: { base_order_info } } = this.props;
        const { status_label, created_at } = base_order_info || {};

        return (
            <div className={ status_label }>
                { /* <h4>{ __('Order details') }</h4> */ }
                <dl>
                    <dt>{ __('Created at: ') }</dt>
                    <dd>{ created_at }</dd>
                    <dt>{ __('Status: ') }</dt>
                    <dd>{ status_label }</dd>
                </dl>
            </div>
        );
    }

    renderPayment() {
        const { order: { payment_info } } = this.props;
        const { additional_information: { method_title } = {} } = payment_info || {};

        return (
            <div>
                <h4>{ __('Payment Information') }</h4>
                <dl>
                    <dt>{ __('Method: ') }</dt>
                    <dd>{ method_title }</dd>
                </dl>
            </div>
        );
    }

    renderShippingAddressTable() {
        const { order: { shipping_info: { shipping_address } } } = this.props;

        return (
            <MyAccountAddressTable
              title={ __('Shipping address') }
              address={ shipping_address }
              mix={ { block: 'MyAccountOrderPopup', elem: 'Address' } }
            />
        );
    }

    renderShipping() {
        const { order: { shipping_info }, currency_code, display_tax_in_shipping_amount } = this.props;

        const {
            shipping_description,
            shipping_address,
            shipping_amount,
            shipping_incl_tax
        } = shipping_info || {};

        if (!shipping_address) {
            return null;
        }

        const amount = display_tax_in_shipping_amount === DISPLAY_CART_TAX_IN_SHIPPING_EXL_TAX
            ? shipping_amount
            : shipping_incl_tax;

        return (
            <div block="MyAccountOrderPopup" elem="ShippingWrapper">
                <h4>{ __('Shipping & Handling Information') }</h4>
                <dl>
                    <dt>{ __('Description: ') }</dt>
                    <dd>
                        { shipping_description }
                    </dd>
                    <dt>{ __('Price: ') }</dt>
                    <dd>
                        { formatPrice(amount, currency_code) }
                    </dd>
                </dl>
                { this.renderShippingAddressTable() }
            </div>
        );
    }

    renderItems() {
        const { order: { order_products = [] }, currency_code } = this.props;

        return order_products.map((product, i) => {
            const {
                name,
                thumbnail,
                id,
                qty,
                row_total
            } = product;

            const { url } = thumbnail || {};

            return (
                <tr
                  key={ id || i.toString() }
                  block="MyAccountOrderPopup"
                  elem="Row"
                >
                    <td data-th="Image">
                        { url && (
                            <Image
                              src={ url }
                              alt={ name }
                              mix={ { block: 'MyAccountOrderPopup', elem: 'Thumbnail' } }
                            />
                        ) }
                    </td>
                    <td data-th="Name"><span>{ name }</span></td>
                    <td data-th="Quantity">{ qty }</td>
                    <td data-th="Total">
                        { formatPrice(row_total, currency_code) }
                    </td>
                </tr>
            );
        });
    }

    renderItemsHeading() {
        return (
            <tr>
                <th>{ __('Image') }</th>
                <th>{ __('Name') }</th>
                <th>{ __('Quantity') }</th>
                <th>{ __('Total') }</th>
            </tr>
        );
    }

    handleTabClick = (activeTab) => {
        this.setState({ activeTab });
    };

    renderTabs = () => {
        const { activeTab = 'order' } = this.state;
        let activeClassOrder = 'tab';
        let activeClassInvoice = 'tab';

        if (activeTab === 'invoice') {
            activeClassInvoice = 'tab_active';
        } else {
            activeClassOrder = 'tab_active';
        }

        const { order: { base_order_info } } = this.props;
        const { status_label } = base_order_info || {};

        // Hide Invoices tab for Pending and Canceled orders
        if (status_label === 'Pending' || status_label === 'Canceled') {
            activeClassOrder = 'tab_active';
            return (
                <div
                  className={ activeClassOrder }
                  onClick={ () => this.handleTabClick('order') }
                >
                      { __('Items Ordered') }
                </div>
            );
        }

        return (
            <>
                <div
                  className={ activeClassOrder }
                  onClick={ () => this.handleTabClick('order') }
                >
                        { __('Items Ordered') }
                </div>
                <div
                  className={ activeClassInvoice }
                  onClick={ () => this.handleTabClick('invoice') }
                >
                        { __('Invoices') }
                </div>
                { /* RMA */ }
                { (status_label === 'Complete' && (isUsaStore() || isRsaStore() || isIntStore() || isAusStore())) && (
                    <div
                      onClick={ () => this.clickReturnsFormPopup() }
                    >
                        { __('Return Request') }
                    </div>
                ) }
            </>
        );
    };

     downloadURL = (data) => {
         const { requestInvoicePdfDetails } = this.props;
         requestInvoicePdfDetails(data);
     };

     downloadAlL = (filepath) => {
         this.setState({ openPfd: true, filepath });
         const newIframe = document.createElement('iframe');
         newIframe.width = '0';
         newIframe.height = '0';
         newIframe.src = filepath;
         document.body.appendChild(newIframe);
     };

     closePdfView= () => {
         this.setState({ openPfd: false, filepath: '' });
     };

    renderInvoiceDetails = () => {
        const { activeTab = 'order', openPfd = false, filepath = '' } = this.state;

        const { rawInvoice = {}, order: { base_order_info = {} } } = this.props;
        const { increment_id, id: order_id } = base_order_info;

        if (activeTab != 'invoice' || isEmpty(rawInvoice) || isEmpty(rawInvoice.invoice_download)) {
            return null;
        }
        if (openPfd && isEmpty(filepath)) {
            return (
                <div>
                    <iframe src={ filepath } height="100%" width="100%" />
                </div>
            );
        }

        const { invoice_download, invoices = [] } = rawInvoice;

        const invicesData = invoices.map((invoice, i) => {
            const {
                invoice_number,
                invoice_id,
                invoice_url
            } = invoice;
            const invoiceTitle = `${__('Invoice #')}${invoice_number}`;

            return (
                <tr
                  key={ invoice_id || i.toString() }
                  block="invoice"
                  elem="Row"
                >
                    <td>
                    <div className="invoice-title">
                <strong>{ invoiceTitle }</strong>
                <div onClick={ () => this.downloadURL({ invoice_number, invoice_id, order_id: '' }) } className="action print">
                    <span>{ __('Print Invoice') }</span>
                </div>
                    { /* <div onClick={ () => this.downloadAlL(invoice_url) } className="action print" target="_blank">
                        <span>{ __('Print Invoice') }</span>
                    </div> */ }
                    </div>
                    </td>
                </tr>
            );
        });

        // Hide Invoices for Pending and Canceled orders
        const { status_label } = base_order_info || {};
        if (status_label === 'Pending' || status_label === 'Canceled') {
            return null;
        }

        return (
            <div className="InvoiceDetails">
            <div className="actions-toolbar">
            <div onClick={ () => this.downloadURL({ order_id, increment_id, invoice_id: '' }) } className="action print">
                <span>{ __('Print All Invoices') }</span>
            </div>
            </div>
             { invicesData }
            </div>
        );
    };

    renderProducts() {
        return (
            <div block="MyAccountOrderPopup" elem="ProductsWrapper">
                { /* <h4>{ __('Items Ordered') }</h4> */ }
                <table
                  block="MyAccountOrderPopup"
                  elem="Products"
                >
                    <thead>
                        { this.renderItemsHeading() }
                    </thead>
                    <tbody>
                        { this.renderItems() }
                    </tbody>
                </table>
            </div>
        );
    }

    renderTotals() {
        const { order: { base_order_info }, currency_code } = this.props;
        const { grand_total, sub_total } = base_order_info || {};

        return (
            <div block="MyAccountOrderPopup" elem="OrderWrapper">
                <h4>{ __('Order Total') }</h4>
                <dl>
                    <dt>{ __('Subtotal: ') }</dt>
                    <dd>
                        { formatPrice(sub_total, currency_code) }
                    </dd>
                    <dt>{ __('Grand total: ') }</dt>
                    <dd>
                        { formatPrice(grand_total, currency_code) }
                    </dd>
                </dl>
            </div>
        );
    }

    clickReturnsFormPopup = () => {
        const { retunesFrom } = this.state;
        const bTag = document.getElementsByTagName('body');
        if (!retunesFrom) {
            this.setState({ retunesFrom: true });
            bTag[0].style.overflowY = 'hidden';
        } else {
            this.setState({ retunesFrom: false });
            bTag[0].style.overflowY = 'unset';
        }
    };

    returnPopupVisiblity(isVisible) {
        this.setState({ retunesFrom: isVisible });
    }

      // render ReturnsForm Popup
      renderReturnsFormPopup = () => {
          const { retunesFrom } = this.state;
          const { rawInvoice = {} } = this.props;

          const { invoices = [] } = rawInvoice;

          const invoiceNumber = invoices[0]?.invoice_number;

          return (
              <ReactPopup
                open={ retunesFrom }
                className="ReturnsForm_Popup_wrap"
                closeOnDocumentClick={ false }
                closeOnEscape={ false }
              >
                  <div className="cross_subs_popup">
                      <button
                        key="close"
                        block="Header"
                        elem="Button"
                        mods={ { type: 'close' } }
                        onClick={ this.clickReturnsFormPopup }
                        aria-label="Close"
                      >
                          <CloseIcon />
                      </button>
                  </div>
              <div className="PopUpWrap">
                  <ReturnsForm isVisible={ this.returnPopupVisiblity.bind(this) } invoiceNumber={ invoiceNumber } />
              </div>
              </ReactPopup>
          );
      };

      renderContent() {
          const { order: { order_products } } = this.props;

          if (!order_products) {
              return null;
          }

          return (
              <>
                { this.renderReturnsFormPopup() }
                { this.renderBaseInfo() }
                <div className="order-tab">
                    { this.renderTabs() }
                </div>
                <div className="order-details-items">
                    { this.renderInvoiceDetails() }
                    { this.renderProducts() }
                    { this.renderTotals() }
                </div>
                <div className="order-details-view">
                    { this.renderPayment() }
                    { this.renderShipping() }
                </div>
              </>
          );
      }

      render() {
          const { isLoading } = this.props;

          return (
            <Popup
              id={ ORDER_POPUP_ID }
              mix={ { block: 'MyAccountOrderPopup' } }
              clickOutside={ false }
            >
                <div block="MyAccountOrderPopup" elem="Content">
                    <Loader isLoading={ isLoading } />
                    { this.renderContent() }
                </div>
            </Popup>
          );
      }
}

export default MyAccountOrderPopupComponent;
